import { render, staticRenderFns } from "./BoxTender.vue?vue&type=template&id=615c6140"
import script from "./BoxTender.vue?vue&type=script&lang=js"
export * from "./BoxTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports